import { put } from "@redux-saga/core/effects";
import { deleteOptionFailure, deleteOptionSuccess } from "../actionCreaters";

import { FieldsService } from "./../../../services/fields";
import { DeleteOptionRequestActionType, optionsResponse } from "./../types";

export function* deleteOptionSaga({ payload: { fieldId, optionId } }: DeleteOptionRequestActionType) {
    try {
        const {
            data: { data },
        }: optionsResponse = yield FieldsService.deleteOption(fieldId, optionId);

        yield put(deleteOptionSuccess({ fieldId, options: data.options }));
    } catch (error) {
        yield put(deleteOptionFailure({ fieldId, optionId }));
    }
}
